import React from "react";
import {
  Box,
  Container,
  Typography,
  Stack,
  Card,
  CardContent,
  Divider,
  Link,
  useTheme,
} from "@mui/material";
import { Email as EmailIcon } from "@mui/icons-material";
import ShopKaBotLeadForm from "./Shared/LeadForm";

const ContactUs: React.FC = () => {
  const theme = useTheme();

  const supportEmail = "merraiofficial@gmail.com";
  const subject = encodeURIComponent("ShopKaBot Automation Inquiry");
  const body = encodeURIComponent(
    "Hi ShopKaBot team,\n\nI want to know more about:\n\n- My business type:\n- Current challenge:\n- Monthly enquiry volume:\n\nThanks!"
  );

  const mailto = `mailto:${supportEmail}?subject=${subject}&body=${body}`;

  return (
    <Box sx={{ py: { xs: 4, sm: 6, md: 8 }, backgroundColor: "#f8fafc" }}>
      <Container maxWidth="lg">
        <Stack spacing={2} sx={{ mb: 5, textAlign: "center" }}>
          <Typography
            variant="h3"
            fontWeight={800}
            sx={{
              fontSize: { xs: "2rem", sm: "2.6rem", md: "3.3rem" },
              background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.success.main})`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Tell Us About Your Business
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ maxWidth: 720, mx: "auto", lineHeight: 1.8 }}
          >
            Share your requirements through the lead form and our team will come back
            with the right WhatsApp automation plan for your business.
          </Typography>
        </Stack>

        <Stack spacing={3} sx={{ maxWidth: 860, mx: "auto" }}>
          <Card sx={{ border: `1px solid ${theme.palette.divider}`, borderRadius: 3 }}>
            <CardContent sx={{ p: { xs: 2.5, sm: 4 } }}>
              <ShopKaBotLeadForm formSize="md" />
            </CardContent>
          </Card>

          <Card sx={{ border: `1px solid ${theme.palette.divider}`, borderRadius: 3 }}>
            <CardContent sx={{ p: { xs: 2.5, sm: 4 }, textAlign: "center" }}>
              <Divider sx={{ mb: 3 }}>or reach us directly</Divider>

              <EmailIcon
                sx={{
                  fontSize: 40,
                  color: theme.palette.primary.main,
                  mb: 1,
                }}
              />

              <Typography variant="h6" fontWeight={800} sx={{ mb: 0.5 }}>
                Email
              </Typography>

              <Typography variant="body1" fontWeight={700} sx={{ mb: 2 }}>
                {supportEmail}
              </Typography>

              <Link
                href={mailto}
                underline="none"
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 1,
                  background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.success.main})`,
                  color: "#fff",
                  fontWeight: 700,
                  py: 1.3,
                  px: 3,
                  borderRadius: 1.5,
                }}
              >
                <EmailIcon fontSize="small" />
                Write an email
              </Link>

              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ mt: 2, display: "block" }}
              >
                If the button doesn&apos;t work, email us directly at {supportEmail}.
              </Typography>
            </CardContent>
          </Card>
        </Stack>
      </Container>
    </Box>
  );
};

export default ContactUs;
